"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var clsx_1 = __importDefault(require("clsx"));
var react_i18next_1 = require("react-i18next");
var _1 = require(".");
require("./LayoutMenu.scss");
var Action_1 = require("../layoutContent/Redux/Action");
var Action_2 = require("./Redux/Action");
var HistoryOperation;
(function (HistoryOperation) {
    HistoryOperation["PushState"] = "PushState";
    HistoryOperation["ReplaceState"] = "ReplaceState";
})(HistoryOperation = exports.HistoryOperation || (exports.HistoryOperation = {}));
function GetCurrentMenuItemEntry(location, menu) {
    // eslint-disable-next-line no-restricted-syntax
    for (var _i = 0, menu_1 = menu; _i < menu_1.length; _i++) {
        var item = menu_1[_i];
        if (item.pathname !== '' &&
            location.pathname.indexOf(item.pathname) !== -1) {
            return [item];
        }
        if (item.subItems) {
            var subarea = GetCurrentMenuItemEntry(location, item.subItems);
            if (subarea) {
                return __spreadArrays([item], subarea);
            }
        }
    }
}
exports.GetCurrentMenuItemEntry = GetCurrentMenuItemEntry;
var mapDispatchToProps = {
    dispatchChangeBreadcrumb: Action_1.changeBreadCrumbAction,
    dispathcMenuNavigation: Action_2.menuNavigationAction
};
var mapStateToProps = function (state) {
    return {
        pageBreadCrumbItems: state.layouHeader.pageBreadcrumbItems,
    };
};
var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
var LayoutMenuComponent = function (props) {
    var opened = props.opened, headerComponent = props.headerComponent, children = props.children, dispatchChangeBreadcrumb = props.dispatchChangeBreadcrumb, dispathcMenuNavigation = props.dispathcMenuNavigation, historyOperation = props.historyOperation;
    var menuItems = props.menuItems, menuOverflow = props.menuOverflow, className = props.className, closeMenuOnClick = props.closeMenuOnClick, disabled = props.disabled;
    var _a = react_1.useState(!!opened), isOpen = _a[0], setIsOpen = _a[1];
    var location = react_router_dom_1.useLocation();
    var t = react_i18next_1.useTranslation(['', 'menu']).t;
    var menuClassName = clsx_1.default('eta-layout-menu', className, isOpen && 'opened', menuOverflow && 'overflow');
    var contentClassName = clsx_1.default('eta-layout-menu-content', menuOverflow && 'overflow');
    var isLinkActive = function (path) {
        if (path === '/') {
            return (location && location.pathname === path);
        }
        return location && location.pathname.indexOf(path) !== -1;
    };
    var isOpened = function (subItems) {
        if (location) {
            // eslint-disable-next-line no-restricted-syntax
            for (var _i = 0, subItems_1 = subItems; _i < subItems_1.length; _i++) {
                var item = subItems_1[_i];
                if (item.subItems) {
                    if (isOpened(item.subItems)) {
                        return true;
                    }
                }
                if (location.pathname.indexOf(item.pathname) !== -1) {
                    return true;
                }
            }
        }
        return false;
    };
    var onNavLinkClicked = react_1.useCallback(function () {
        dispatchChangeBreadcrumb([]); // erase the breadcrumbState when click on menu
        if (closeMenuOnClick && isOpen) {
            setIsOpen(false);
        }
    }, [isOpen, closeMenuOnClick]);
    var history = react_router_dom_1.useHistory();
    var renderItem = function (item) {
        return (react_1.default.createElement(react_1.Fragment, { key: item.id + "_fragment" },
            !item.subItems && (react_1.default.createElement(react_router_dom_1.NavLink, { key: item.id, id: item.id, title: t(item.title), to: { pathname: item.pathname }, className: clsx_1.default('layout-menu-nav-item', disabled && 'layout-menu-nav-item--disabled'), activeClassName: "layout-menu-nav-item--active", onClick: function (ev) {
                    if (disabled) {
                        ev.preventDefault();
                    }
                    else {
                        if (item.queryString && historyOperation) {
                            ev.preventDefault();
                            switch (historyOperation) {
                                case HistoryOperation.PushState:
                                    history.push(item.queryString);
                                    break;
                                case HistoryOperation.ReplaceState:
                                    history.replace(item.queryString);
                                    break;
                                default:
                                    break;
                            }
                        }
                        if (dispathcMenuNavigation) {
                            dispathcMenuNavigation(item);
                        }
                        onNavLinkClicked();
                    }
                }, isActive: function () { return isLinkActive(item.pathname); } },
                react_1.default.createElement(_1.LayoutMenuIcon, { className: "layout-menu-nav-item-icon", iconName: item.iconName, showBadge: item.showBadge }),
                react_1.default.createElement("div", { className: "layout-menu-nav-item-label" }, t(item.title)))),
            item.subItems && (react_1.default.createElement(_1.LayoutNavLinkGroup, { key: item.id + "_group", item: item, mainMenuExpend: isOpen, opened: isOpened(item.subItems) }, item.subItems.map(function (subItem) { return renderItem(subItem); })))));
    };
    var HeaderComponent = headerComponent !== null && headerComponent !== void 0 ? headerComponent : _1.LayoutMenuHeader;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: menuClassName },
            react_1.default.createElement(HeaderComponent, { opened: isOpen, onToggled: function () { return setIsOpen(!isOpen); } }),
            menuItems.map(function (item) { return renderItem(item); })),
        react_1.default.createElement("div", { className: contentClassName }, children)));
};
exports.LayoutMenu = connector(LayoutMenuComponent);
//# sourceMappingURL=LayoutMenu.js.map